var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comp-divider"},[_c('p',{directives:[{name:"markdown",rawName:"v-markdown",value:(_vm.attributes.value),expression:"attributes.value"}],staticClass:"content"})])}
var staticRenderFns = []

export { render, staticRenderFns }